import { createContext, useContext, useRef, useState } from 'react'

const AnnounceContext = createContext(() => {})

export const AriaAnnouncerProvider = ({ children }) => {
  const queue = useRef([])
  const [message, setMessage] = useState('')
  const isAnnouncing = useRef(false)
  const lastMessage = useRef('')

  const processQueue = () => {
    if (queue.current.length === 0) {
      isAnnouncing.current = false
      return
    }

    const msg = queue.current.shift()
    if (msg === lastMessage.current) {
      processQueue()
      return
    }

    lastMessage.current = msg
    setMessage(msg)

    setTimeout(() => {
      setMessage('')
      setTimeout(() => {
        processQueue()
      }, 100)
    }, 2000)
  }

  const announce = (msg) => {
    if (!msg) return

    queue.current.push(msg)
    if (!isAnnouncing.current) {
      isAnnouncing.current = true
      processQueue()
    }
  }

  return (
    <AnnounceContext.Provider value={announce}>
      {children}
      <div
        aria-live='polite'
        aria-atomic='true'
        style={{
          position: 'absolute',
          left: '-9999px',
          height: '1px',
          width: '1px',
          overflow: 'hidden',
        }}
      >
        {message}
      </div>
    </AnnounceContext.Provider>
  )
}

export const useAriaAnnouncer = () => useContext(AnnounceContext)
